import { getMultiStepQuizTemplate, getMultiStepQuizWithLoaderTemplate } from "../../shortcodes/templates";
import { getShortcodeWrapper, addShortcodeToEditor } from "../../shortodeAddition";
import { decodeHtmlSymbols } from "@/utility/htmlEscape";

const editMultiStepQuizConfig = (editor, quizDataDiv) => {
  let withLoader = quizDataDiv.classList.contains("quiz-with-loader");

  let existData = JSON.stringify(decodeHtmlSymbols(quizDataDiv.getAttribute("data-multi-step-quiz-data")));
  let currentData = null;

  editor.windowManager.openUrl({
    title: "Multi-Step Quiz #1",
    url: "/multi-step-quiz-dialog?data=" + existData,
    buttons: [
      {
        type: "cancel",
        name: "close",
        text: "Cancel",
      },
      {
        type: "custom",
        name: "submit",
        text: "Submit",
        primary: true,
      },
    ],
    onAction: function (instance, message) {
      editor.windowManager.alert("Success!");
      quizDataDiv.setAttribute("data-multi-step-quiz-data", currentData);
      // We have to call change function here to updateMainContent in form component
      editor.fire("change");
      instance.close();
    },
    onMessage: (instance, message) => {
      currentData = message.data;
    },
    width: window.innerWidth - 20,
    height: window.innerHeight - 20,
  });
};

const multiStepQuizConfig = (tinymce, uuid, shortcodeOnClick, withLoader = false) => {
  let currentData = null;

  tinymce.activeEditor.windowManager.openUrl({
    title: "Multi-Step Quiz #1",
    url: "/multi-step-quiz-dialog?data=null",
    buttons: [
      {
        type: "cancel",
        name: "close",
        text: "Cancel",
      },
      {
        type: "custom",
        name: "submit",
        text: "Submit",
        primary: true,
      },
    ],
    onAction: function (instance, message) {
      const parentElement = tinymce.activeEditor.selection.getNode().nodeName.toLowerCase();
      let templateToAdd;
      if (withLoader) {
        templateToAdd = getMultiStepQuizWithLoaderTemplate();
      } else {
        templateToAdd = getMultiStepQuizTemplate();
      }
      const shortcodeWrapperString = getShortcodeWrapper(uuid, shortcodeOnClick, templateToAdd, "multi-step-quiz-v1");

      // prevent tinyMCE for breaking the data-multi-step-quiz-data parameter and destroying the shortcode by creating dom element and setting the data-multi-step-quiz-data parameter
      const tempWrapper = document.createElement("div");
      tempWrapper.innerHTML = shortcodeWrapperString.trim();
      tempWrapper
        .querySelector("div[data-multi-step-quiz-data]")
        ?.setAttribute("data-multi-step-quiz-data", currentData);

      addShortcodeToEditor(tempWrapper.innerHTML, uuid, parentElement);
      instance.close();
    },
    onMessage: (instance, message) => {
      currentData = message.data;
    },
    width: window.innerWidth - 20,
    height: window.innerHeight - 20,
  });
};

export { multiStepQuizConfig, editMultiStepQuizConfig };
